import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Basics, isMobile } from '../_app/cuchillo/core/Basics';
import { Metrics } from '../_app/cuchillo/core/Metrics';

class ScrollItem__SliderThumbnails extends VScroll_Item {
    _call;
    _slider;
    _thumbs = [];
    _thumb;

    _calls = {
        loop: () => this.loop(),
        click: e => this.click(e)
    }

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        if (!isMobile) {
            this._slider = new SliderScroll(__link, {
                interaction: true,
                hasScrollbar: false,
                itemClass: ScrollItem__SliderImages__Thumbnail
            });

            this._thumbs = GetBy.class('__thumb', __link);
            for (let i = 0; i < this._thumbs.length; i++) {
                const thumb = this._thumbs[i];
                thumb.addEventListener(Basics.clickEvent, this._calls.click);
            }

            const thumb = GetBy.class('__thumbnail', __link)[0];
            this._thumb = new ThumbnailScroller(thumb);
        }

        this.onShow = () => {
            gsap.ticker.add(this._calls.loop);
        };

        this.onHide = () => {
            gsap.ticker.remove(this._calls.loop);
        };
    }

    resize(w, h) {
        super.resize(w, h);
        if (this._slider) this._slider.resize();
    }

    loop() {
        if (isMobile) return;

        if (this._slider) this._slider.loop();

        if (this._thumb) {
            const p = this._slider.progress;
            this._thumb.loop(p);
        }

        const current = this._slider.current;
        for (let i = 0; i < this._thumbs.length; i++) {
            const thumb = this._thumbs[i];
            if (i === current) thumb.classList.add('--active');
            else thumb.classList.remove('--active');
        }
    }

    click(e) {
        const i = parseInt(e.target.dataset.index);
        this._slider.gotoIndex(i)
    }

    dispose() {
        if (this._slider) this._slider.dispose();

        for (let i = 0; i < this._thumbs.length; i++) {
            const thumb = this._thumbs[i];
            thumb.removeEventListener(Basics.clickEvent, this._calls.click);
        }

        super.dispose();
    }

    resize() {
        super.resize();

        if (this._slider) this._slider.resize();
        if (this._thumb) this._thumb.resize();
    }
}

class ThumbnailScroller {
    containerWidth;
    trackWidth;
    maxOffset;

    constructor(__container) {
        this.container = __container;
        this.track = GetBy.class('__track', __container)[0];
        this.resize();
    }

    loop(progress) {
        const offset = -progress * this.maxOffset;
        this.track.style.transform = `translateX(${offset}px)`;
    }

    resize() {
        this.containerWidth = Metrics.WIDTH;
        this.trackWidth = this.track.scrollWidth;
        this.maxOffset = Math.max(this.trackWidth - this.containerWidth, 0);

        this.loop(0);
    }
}

class ScrollItem__SliderImages__Thumbnail extends VScroll_Item {
    hasHiddenEnabled = false;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }

    //==================================================================================================================
    //          PUBLIC
    //==================================================================================================================

    //update () {
    /* if (this.progress > .5) {
       const p = Math.max(0, Maths.normalize(1, .5, this.progress));
       this._x = this._x + ((Metrics.WIDTH * .5) * p);
     }*/
    /* super.update();
  }

  mouseOver () { }
  mouseDown () { }
  mouseUp () { }

  show () {
    super.show();
  }

  hide () {
    super.hide();
  }*/
}

Scroll._registerClass('SliderThumbnails', ScrollItem__SliderThumbnails);
